import { createAction, props } from '@ngrx/store';
import { Locales, Report, StandardsViewerModalMfeData, UserRole } from './multi-stage-assignment-report.model';
import {
    getAssessmentSequence_getAssessmentSequence as AssessmentSequence,
    getStandardsMetadata_getStandardsMetadata as StandardMetadata,
    getUserFeatureAttributes_getUserFeatureAttributes as UserFeatureAttributes
} from '../../../../../schema/graphql-types';
import {MultiStageReportPlayerData} from '../../model/multi-stage-report-player.model';

export enum MultiStageAssignmentReportActionTypes {
    SetIsLoading = '[Multi Stage Assignment Report] Set IsLoading',
    SetUserRole = '[Multi Stage Assignment Report] Set User Role',
    SetStudentReport = '[Multi Stage Assignment Report] Set Student Report',
    SetLanguageLocale = '[Multi Stage Assignment Report] Set Language Locale',
    SetIsErrorOccurred = '[Multi Stage Assignment Report] Set Is Error Occurred',
    GetMultiStageReport = '[Multi Stage Assignment Report] Get Student Report',
    SetSelectedStudentData = '[Multi Stage Assignment Report] Set Selected Student Data',
    SetIsZeroState = '[Multi Stage Assignment Report] Set Is Zero State',
    SetAssessmentSequence = '[Multi Stage Assignment Report] Set Assessment Sequence',
    GetAssessmentSequence = '[Multi Stage Assignment Report] Get Assessment Sequence',
    GetStandardMetadata = '[Multi Stage Assignment Report] Get Standard Metadata',
    SetStandardMetadata = '[Multi Stage Assignment Report] Set Standard Metadata',
    SetIsAuthenticated = '[Multi Stage Assignment Report] Set IsAuthenticated',
    SetUserFeatureAttributes = '[Multi Stage Assignment Report] Set User Feature Attributes',
    SetInputParams = '[Multi Stage Assignment Report] Set Input Parameters',
    SetStandardsModalPayload = '[Multi Stage Assignment Report] Set Standards Modal Payload Data',
    SetIsStandardModalVisible = '[Multi Stage Assignment Report] Set Is Standards Modal Visible Status',
    ResetStandardsMetaData = '[Multi Stage Assignment Report] Reset Standards Metadata',
    ResetStore = '[Multi Stage Assignment Report] Reset Store',
}

export const ActionSetIsAuthenticated = createAction(
    MultiStageAssignmentReportActionTypes.SetIsAuthenticated,
    props<{ isAuthenticated: boolean }>()
);

export const ActionSetIsLoading = createAction(
    MultiStageAssignmentReportActionTypes.SetIsLoading,
    props<{ isLoading: boolean }>()
);

export const ActionSetUserRole = createAction(
    MultiStageAssignmentReportActionTypes.SetUserRole,
    props<{ userRole: UserRole }>()
);

export const ActionSetUserFeatureAttributes = createAction(
    MultiStageAssignmentReportActionTypes.SetUserFeatureAttributes,
    props<{ userFeatureAttributes: UserFeatureAttributes[] }>()
);

export const ActionSetStudentReport = createAction(
    MultiStageAssignmentReportActionTypes.SetStudentReport,
    props<{ report: Report }>()
);

export const ActionSetAssessmentSequence = createAction(
    MultiStageAssignmentReportActionTypes.SetAssessmentSequence,
    props<{ assessmentSequence: AssessmentSequence[] }>()
);

export const ActionSetLanguageLocale = createAction(
    MultiStageAssignmentReportActionTypes.SetLanguageLocale,
    props<{ locale: Locales }>()
);

export const ActionSetIsErrorOccurred = createAction(
    MultiStageAssignmentReportActionTypes.SetIsErrorOccurred,
    props<{ isErrorOccurred: boolean }>()
);

export const ActionGetMultiStageReport = createAction(MultiStageAssignmentReportActionTypes.GetMultiStageReport);

export const ActionGetAssessmentSequence = createAction(
    MultiStageAssignmentReportActionTypes.GetAssessmentSequence,
    props<{ assessmentSessionIds: string[] }>()
);

export const ActionSetIsZeroState = createAction(
    MultiStageAssignmentReportActionTypes.SetIsZeroState,
    props<{ isZeroState: boolean }>()
);

export const ActionGetStandardMetadata = createAction(
    MultiStageAssignmentReportActionTypes.GetStandardMetadata,
    props<{ skillCodes: string[] }>()
);

export const ActionSetStandardMetadata = createAction(
    MultiStageAssignmentReportActionTypes.SetStandardMetadata,
    props<{ standardMetadata: StandardMetadata[] }>()
);

export const ActionSetStandardsModalPayload = createAction(
    MultiStageAssignmentReportActionTypes.SetStandardsModalPayload,
    props<{standardsModalPayload: StandardsViewerModalMfeData}>()
);

export const ActionSetIsStandardModalVisible = createAction(
    MultiStageAssignmentReportActionTypes.SetIsStandardModalVisible,
    props<{isStandardModalVisible: boolean}>()
);

export const ActionSetInputParams = createAction(
    MultiStageAssignmentReportActionTypes.SetInputParams,
    props<{ inputParams: MultiStageReportPlayerData }>(),
);

export const ActionResetStandardsMetaData = createAction(MultiStageAssignmentReportActionTypes.ResetStandardsMetaData);

export const ActionResetStore = createAction(MultiStageAssignmentReportActionTypes.ResetStore);
